import { Chip, MenuItem, Select, Typography } from '@material-ui/core';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import produce from 'immer';
import * as React from 'react';
import { connect } from 'react-redux';
import axios from '../../axios-pod';
import Snooze from '../../components/Snooze/Snooze';
import SubheadingBar from '../../components/SubheadingBar/SubheadingBar';
import MainHeading from '../../components/UI/MainHeading/MainHeading';
import MainSection from '../../components/UI/MainSection/MainSection';
import MyDialog from '../../components/UI/MyDialog/MyDialog';
import MySnackbars from '../../components/UI/MySnackbars/MySnackbars';
import MyTableLoader from '../../components/UI/MyTableLoader/MyTableLoader';
import SubHeading from '../../components/UI/SubHeading/SubHeading';
import SubSection from '../../components/UI/SubSection/SubSection';
import {
  IAsset,
  IConfirmationDialogState,
  IFeed,
  IFilter,
  IFilterState,
  IState,
  IUser
} from '../../models/states';
import {
  escalate,
  fetchAssetRejected,
  fetchAssets,
  flushSelectedAssets,
  resolveAsset,
  snoozeAssets,
  toggleSelectedAssets
} from '../../store/actions/assetActions';
import { updateFilters } from '../../store/actions/filterActions';
import {
  ConfirmationTypes,
  initialConfirmationState,
  prioritiesToEscalate,
  UserRoles
} from '../../utilities/utilities';
import withErrorHandler from '../../utilities/withErrorHandler';
import ConfirmationDialog from './../../components/UI/ConfirmationDialog/ConfirmationDialog';
import AssetSummary from './AssetSummary';
import IngestPodTable from './IngestPodTable';
const styles = () =>
  createStyles({
    root: {},
    actionButtons: {
      marginRight: '1rem'
    },
    assetSummaryDialog: {
      maxWidth: '80%'
    },
    selectField: {
      background: 'rgba(255,255,255,0.2)',
      margin: '0 0.635rem',
      paddingLeft: '10px'
    },
    escalateWrapper: {
      display: 'flex',
      alignItems: 'flex-end',
      marginBottom: '1.5rem'
    }
  });

class IngestPod extends React.Component<IIngestPodProps, IIngestPodState> {
  intervalId: any;
  constructor(props: IIngestPodProps) {
    super(props);

    this.state = {
      orderBy: 'srNo',
      order: 'asc',
      page: 0,
      rowsPerPage: 25,
      filters: {},
      searchText: '',
      isOpenFilters: {
        feeds: false,
        status: false,
        mediaType: false,
        state: false
      },
      selectedScreen: 'all',
      openSnackbar: false,
      variant: 'info',
      snackbarMessage: '',
      snoozeHrs: 0,
      snoozeMins: 0,
      openAssetSummary: false,
      selectedAsset: undefined,
      // selectedSupervisor: undefined,
      selectedPriority: undefined,
      confirmationDialogProps: initialConfirmationState
    };
  }

  handleChangePage = (event: React.MouseEvent<HTMLElement>, page: number) => {
    this.setState({ page });
  };
  handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10) });
  };

  handleRequestSort = (
    event: React.MouseEvent<HTMLElement>,
    property: string
  ) => {
    const orderBy = property;
    let order: 'asc' | 'desc' = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ orderBy, order });
  };
  handleOpenNotification = (message: string, variant: string) => {
    this.setState({
      openSnackbar: true,
      variant,
      snackbarMessage: message
    });
  };
  handleIngestEscalate = (id: string) => {
    this.setState({ selectedAsset: id }, () => {
      this.handleOpenEscalateAllForm();
    });
  };

  handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ searchText: event.target.value.toLowerCase() });
  };
  handleToggleHeaderFilters = (key: string) => {
    const updatedIsOpenFilter = { ...this.state.isOpenFilters };
    updatedIsOpenFilter[key] = !this.state.isOpenFilters[key];
    this.setState({ isOpenFilters: updatedIsOpenFilter });
  };

  handleFilterToggle = (filterName: string, filter: IFilter) => {
    this.props.updateFilters('assets', filterName, filter);
  };
  handleSnackbarClose = (event: any, reason: any) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ openSnackbar: false });
  };

  handleSelectSupervisor = e => {
    this.setState({ selectedPriority: e.target.value });
  };

  handleOpenEscalateAllForm = () => {
    // const supervisors = this.props.users.filter(
    //   user => user.role === UserRoles.SUPERVISOR
    // );
    this.setState({
      // selectedSupervisor:
      //   supervisors.length > 0 ? supervisors[0].userId : undefined,
      selectedPriority: prioritiesToEscalate.length ? 1 : undefined,
      confirmationDialogProps: {
        type: ConfirmationTypes.ESCALATE,
        open: true,
        onCloseDialog: this.handleCloseEscalateAllForm,
        onProceedDialog: this.handleEscalateAll,
        content: this.renderEscalateAllForm(),
        title: 'escalate'
        // proceedDisabled: !this.state.selectedSupervisor
      }
    });
  };
  handleCloseEscalateAllForm = () => {
    this.setState({
      confirmationDialogProps: initialConfirmationState,
      selectedPriority: prioritiesToEscalate.length ? 1 : undefined
      // selectedSupervisor: undefined
    });
  };
  handleEscalateAll = () => {
    const payload = {
      ids: [this.state.selectedAsset],
      user_id: this.props.user.userId,
      priority: this.state.selectedPriority,
      // assignee: this.state.selectedSupervisor,
      screen: this.props.selectedScreen
    };
    this.props.escalate(payload);
    this.handleCloseEscalateAllForm();
  };
  handleOpenSnoozeForm = () => {
    this.setState({
      confirmationDialogProps: {
        type: ConfirmationTypes.SNOOZE,
        open: true,
        onCloseDialog: this.handleCloseSnoozeForm,
        onProceedDialog: this.handleSnooze,
        content: this.renderSnoozeForm(),
        title: 'Snooze Assets'
      }
    });
  };
  handleCloseSnoozeForm = () => {
    this.setState({
      snoozeHrs: 0,
      confirmationDialogProps: initialConfirmationState
    });
  };
  handleSnooze = () => {
    const payload = {
      selected_assets: produce([], draft => {
        draft.push(this.state.selectedAsset);
      }),
      user_id: this.props.user.userId,
      epoch: Math.floor(
        Math.floor(this.state.snoozeHrs) * 3600 +
          Math.floor(this.state.snoozeMins) * 60
      )
    };
    this.props.snoozeAssets(payload);
    this.handleCloseSnoozeForm();
    this.handleCloseAssetSummary();
  };
  handleSnoozeChange = (e, type: string) => {
    if (type === 'hrs') {
      this.setState({ snoozeHrs: parseInt(e.target.value, 10) });
    } else {
      this.setState({ snoozeMins: parseInt(e.target.value, 10) });
    }
  };
  handleCloseResolveForm = () => {
    this.setState({
      confirmationDialogProps: initialConfirmationState
    });
  };
  handleOpenResolveForm = () => {
    this.setState({
      confirmationDialogProps: {
        type: ConfirmationTypes.RESOLVE,
        open: true,
        onCloseDialog: this.handleCloseResolveForm,
        onProceedDialog: this.handleResolve,
        content: this.renderResolveForm(),
        title: 'Resolve'
      }
    });
  };
  handleResolve = () => {
    const payload = {
      selected_assets: [this.state.selectedAsset],
      user_id: this.props.user.userId,
      epoch: 0
    };
    this.props.resolveAsset(payload);
    this.handleCloseResolveForm();
    this.handleCloseAssetSummary();
  };
  handleOpenAssetSummary = (assetId: string) => {
    this.setState({ openAssetSummary: true, selectedAsset: assetId });
  };
  handleCloseAssetSummary = () => {
    this.setState({ openAssetSummary: false });
  };

  getFilteredData = () => {
    const { filters } = this.props;
    let assets = [...Object.values(this.props.assetMap)];
    // write separate filter for action

    Object.keys(filters.assets).map(filterName => {
      const filterList = filters.assets[filterName];
      const filterListWithSetLabel = filterList.filter(filter => filter.isSet);
      const filterListWithSetLabelList = filterListWithSetLabel.map(
        (filter: any) => {
          return filter.label;
        }
      );
      if (filterListWithSetLabel.length > 0) {
        assets = assets.filter((asset: any) => {
          if (
            filterListWithSetLabelList.indexOf(asset[filterName]) !== -1 ||
            (Array.isArray(asset[filterName]) &&
              asset[filterName]
                .map(feedCode => `${feedCode}#${asset.customer}`)
                .filter(
                  (value: any) =>
                    -1 !== filterListWithSetLabelList.indexOf(value)
                ).length > 0)
          ) {
            return true;
          } else {
            return false;
          }
        });
      }
    });
    return assets;
  };

  renderEscalateAllForm = () => {
    const { classes } = this.props;
    return (
      <div className={classes.escalateWrapper}>
        <Typography>{`Please select the priority to escalate : `}</Typography>
        <Select
          id="supervisorId"
          value={this.state.selectedPriority}
          // value={
          //   this.state.selectedSupervisor ? this.state.selectedSupervisor : ''
          // }
          className={classes.selectField}
          onChange={e => this.handleSelectSupervisor(e)}
          margin="none"
          name="supervisorId"
        >
          {prioritiesToEscalate.map((priority: string) => {
            return (
              <MenuItem
                key={prioritiesToEscalate.indexOf(priority)}
                value={prioritiesToEscalate.indexOf(priority) + 1}
              >
                {priority}
              </MenuItem>
            );
          })}
          {/* {this.props.users
            .filter(user =>
              user.role === UserRoles.SUPERVISOR &&
              user.screens.indexOf(this.props.selectedScreen) !== -1
                ? true
                : false
            )
            .map((user: IUser) => {
              return (
                <MenuItem key={user.userId} value={user.userId}>
                  {user.name}
                </MenuItem>
              );
            })} */}
        </Select>
      </div>
    );
  };

  renderResolveForm = () => {
    return (
      <div>
        <Typography>{`This will resolve the ticket and remove this item from the Pod. Do you wish to continue?`}</Typography>
      </div>
    );
  };

  renderSnoozeForm = () => {
    return (
      <Snooze
        hrs={this.state.snoozeHrs}
        mins={this.state.snoozeMins}
        para={undefined}
        onChangeSnoozeTime={this.handleSnoozeChange}
      />
    );
  };

  renderConfirmationContent = () => {
    switch (this.state.confirmationDialogProps.type) {
      case ConfirmationTypes.SNOOZE:
        return this.renderSnoozeForm();
      case ConfirmationTypes.ESCALATE:
        return this.renderEscalateAllForm();
      case ConfirmationTypes.RESOLVE:
        return this.renderResolveForm();
      default:
        return null;
    }
  };
  componentDidMount() {
    this.props.fetchAssets(true);
  }

  componentWillUnmount() {
    this.props.fetchAssetRejected();
  }

  public render() {
    const { classes } = this.props;
    const data = this.getFilteredData();
    // let filteredData = data

    const filteredData = data.filter(d => {
      return (
        d.assetId.toLowerCase().indexOf(this.state.searchText) !== -1
        // d.feeds.toLowerCase().indexOf(this.state.searchText) !== -1
      );
    });
    const totalItems = this.props.assetIds.length;
    return (
      <MainSection>
        <MainHeading
          mainHeading={'Ingest Monitor'}
          searchPlaceholder={'Search by Asset ID...'}
          onSearch={this.handleSearch}
          showButton={false}
        />
        <SubSection>
          <SubHeading>
            <SubheadingBar
              title={'Assets'}
              filteredItems={filteredData.length}
              totalItems={totalItems}
              filters={this.props.filters.assets}
              toggleFilter={this.handleFilterToggle}
              showLoading={true}
              loading={this.props.isFetching}
              lastFetched={this.props.lastFetched}
            />
          </SubHeading>
          {this.props.isFetching && this.props.fetchCount === 1 ? (
            <MyTableLoader />
          ) : (
            <IngestPodTable
              assets={filteredData}
              multiSelect={false}
              order={this.state.order}
              orderBy={this.state.orderBy}
              page={this.state.page}
              rowsPerPage={this.state.rowsPerPage}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
              onToggleFilters={this.handleFilterToggle}
              isOpenFilters={this.state.isOpenFilters}
              filters={this.props.filters.assets}
              onRequestSort={this.handleRequestSort}
              onToggleHeaderFilters={this.handleToggleHeaderFilters}
              onEscalate={this.handleIngestEscalate}
              onToggleSelectedAssets={this.props.toggleSelectedAssets}
              onFlushSelectedAssets={this.props.flushSelectedAssets}
              selectedAssets={this.props.selectedAssets}
              onOpenAssetSummary={this.handleOpenAssetSummary}
              onCloseAssetSummary={this.handleCloseAssetSummary}
              feedMap={this.props.feedMap}
            />
          )}
          <MySnackbars
            open={this.state.openSnackbar}
            variant={this.state.variant}
            onClose={this.handleSnackbarClose}
            message={this.state.snackbarMessage}
          />
        </SubSection>
        <ConfirmationDialog
          {...this.state.confirmationDialogProps}
          proceedDisabled={false}
          // proceedDisabled={
          //   this.state.confirmationDialogProps.type ===
          //     ConfirmationTypes.ESCALATE && !this.state.selectedSupervisor
          //     ? true
          //     : false
          // }
        >
          {this.renderConfirmationContent()}
        </ConfirmationDialog>
        <MyDialog
          open={this.state.openAssetSummary}
          onClose={this.handleCloseAssetSummary}
          title={'Asset Summary'}
          maxWidth={false}
        >
          <AssetSummary
            asset={this.props.assetMap[this.state.selectedAsset]}
            isOperator={
              this.props.user && this.props.user.role === UserRoles.OPERATOR
                ? true
                : false
            }
            onOpenEscalateForm={this.handleOpenEscalateAllForm}
            onOpenSnoozeForm={this.handleOpenSnoozeForm}
            onOpenResolveForm={this.handleOpenResolveForm}
            feedMap={this.props.feedMap}
          />
        </MyDialog>
      </MainSection>
    );
  }
}

export interface IIngestPodOwnProps extends WithStyles<typeof styles> {}

interface IIngestPodStateProps {
  assetMap: { [key: string]: IAsset };
  assetIds: string[];
  selectedAssets: string[];
  filters: IFilterState;
  isAuthenticated: boolean;
  selectedScreen: string;
  isFetching: boolean;
  user: IUser;
  users: IUser[];
  feedMap: { [key: string]: IFeed };
  fetchCount: number;
  lastFetched: string;
}
interface IIngestPodDispatchProps {
  updateFilters: (
    filterType: string,
    filterName: string,
    filter: IFilter
  ) => any;
  escalate: (payload: any) => any;
  toggleSelectedAssets: (assets: string[]) => any;
  flushSelectedAssets: () => any;
  snoozeAssets: (payload: any) => any;
  resolveAsset: (payload: any) => any;
  fetchAssetRejected: () => any;
  fetchAssets: (resetFilters: boolean) => any;
}
type IIngestPodProps = IIngestPodOwnProps &
  IIngestPodStateProps &
  IIngestPodDispatchProps;

export interface IIngestPodState {
  orderBy: string;
  order: 'asc' | 'desc';
  page: number;
  rowsPerPage: number;
  filters: any;
  searchText: string;
  isOpenFilters: {
    feeds: boolean;
    status: boolean;
    mediaType: boolean;
    state: boolean;
    [key: string]: any;
  };
  selectedScreen: string;
  openSnackbar: boolean;
  variant: string;
  snackbarMessage: string;
  snoozeHrs: number; // hrs
  snoozeMins: number;
  openAssetSummary: boolean;
  selectedAsset: string; // Asset selected to show summary
  // selectedSupervisor: string; // supervisor id to raise jira ticket
  selectedPriority: number; // priority to raise freshdesk ticket
  confirmationDialogProps: IConfirmationDialogState;
}

const mapStateToProps = (state: IState): IIngestPodStateProps => {
  return {
    assetMap: state.assets.assetMap,
    assetIds: state.assets.assetIds,
    selectedAssets: state.assets.selectedAssets,
    isFetching: state.assets.isFetching,
    filters: state.filters,
    isAuthenticated: state.user.token.length !== 0,
    user: state.user.userInfo,
    users: state.user.users,
    feedMap: state.feeds.feedMap,
    selectedScreen: state.screens.selectedScreen,
    fetchCount: state.assets.fetchCount,
    lastFetched: state.assets.lastFetched
  };
};
const mapDispatchToProps: IIngestPodDispatchProps = {
  updateFilters,
  escalate,
  toggleSelectedAssets,
  snoozeAssets,
  resolveAsset,
  flushSelectedAssets,
  fetchAssetRejected,
  fetchAssets
};

export default withStyles(styles)(
  connect<IIngestPodStateProps, IIngestPodDispatchProps, IIngestPodOwnProps>(
    mapStateToProps,
    mapDispatchToProps
  )(withErrorHandler(IngestPod, axios))
);
